import { Link, Stack } from '@mui/material';
import { Box } from '@mui/system';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

const SocialNav = ({ data }) => (
  <Stack direction='row' justifyContent='center' spacing={{ xs: 2, sm: 4 }}>
    {data?.SocialNav?.map((link, i) =>
      link.Link.map(nav => (
        <Link key={i} href={nav?.link} sx={{ cursor: 'pointer' }}>
          {link?.image && (
            <Box
              component='img'
              sx={{ height: '24px', width: '24px' }}
              src={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${link?.image?.data?.attributes?.url}`}
              alt={link?.image?.data?.attributes?.alternativeText}
            />
          )}
        </Link>
      ))
    )}
  </Stack>
);
export default SocialNav;
